import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const remove = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const push = useCallback((message, { type = 'success', duration = 3000 } = {}) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type }]);
    if (duration > 0) {
      setTimeout(() => remove(id), duration);
    }
    return id;
  }, [remove]);

  const value = { push, remove };

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="fixed top-4 right-4 z-[2000] space-y-3 w-72">
        {toasts.map((t) => (
          <div
            key={t.id}
            className={`group relative px-4 py-3 rounded-lg shadow-md backdrop-blur-md border flex items-start gap-3 text-sm animate-fade-in cursor-pointer transition hover:shadow-lg ${t.type === 'error' ? 'bg-red-500/15 border-red-400/40 text-red-200' : 'bg-green-500/15 border-green-400/40 text-green-200'}`}
            onClick={() => remove(t.id)}
          >
            <div className="font-medium flex-1 leading-snug">{t.message}</div>
            <button className="opacity-60 hover:opacity-100 text-xs">✕</button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}

// Simple fade-in animation (optional tailwind config could handle this)
// If not available, include minimal CSS in index.css:
// .animate-fade-in { animation: fade-in 0.25s ease; }
// @keyframes fade-in { from { opacity:0; transform:translateY(-4px);} to { opacity:1; transform:translateY(0);} }
